import * as React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { LoadingIndicator } from 'lib/components';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { MdDeleteForever } from 'react-icons/md';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
interface Props {
  onClose: (params?: any) => void;
  onDelete: (params?: any) => void;
  // data: ListWebsiteOverlay;
  modalLoading: boolean;
}

interface RowProps {
  justifyContent?: string;
  maxWidth?: string;
}

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const Row = styled.section<RowProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'flex-start'};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  margin-bottom: 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
  button {
    margin-left: 12px;
  }
`;

const Title = styled.h2`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.coal};
`;

const CloseIconWrap = styled.div`
  display: flex;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const TitleHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  color: ${theme.palette.black_1_100};
  justify-content: space-between;
  p {
    margin: 0;
  }
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
`;

const TitleBody = styled.p`
  font-size: 14px;
  line-height: 1.43;
  color: ${theme.palette.black_1_100};
`;

export const ModalSwitchCta = (props: Props) => {
  const { t } = useTranslation();
  const { onClose, onDelete, modalLoading } = props;
  const themes = useTheme();
  return (
    <Modal>
      <Content>
        {modalLoading && (
          <LoadingIndicator
            isLoading={true}
            color={themes.colors.primary[100]}
            height='100%'
            zIndex={2}
          />
        )}
        <Row justifyContent={'space-between'}>
          <TitleContent>
            <TitleHeader>
              <Title>{t('Leave without saving changes?')}</Title>
              <CloseIconWrap>
                <IoMdClose
                  size={24}
                  onClick={onClose}
                  color={theme.palette.midGrey}
                />
              </CloseIconWrap>
            </TitleHeader>
            <TitleBody>
              {t(
                'Your updates will not be saved. This action can’t be undone.'
              )}
            </TitleBody>
          </TitleContent>
        </Row>
        <Row justifyContent={'flex-end'}>
          <Button
            variant='destructive'
            icon={<MdDeleteForever />}
            text={t('Leave this Section')}
            onClick={() => onDelete()}
          />
          <Button text={t('Stay on this Section')} onClick={() => onClose()} />
        </Row>
      </Content>
    </Modal>
  );
};
